<template>
  <div
    class="full-height full-width is-flex is-flex-direction-column is-justify-content-space-between"
  >
    <div class="full-width register-completed">
      <img
        src="@/assets/images/logo-inverted.svg"
        alt="Logo"
        class="register-completed--logo"
      />
      <div class="
        is-align-items-center
        is-flex
        is-flex-direction-column
        is-justify-content-center
        register-completed--content
      ">
        <div class="mb-9">
          <h1 class="has-text-black has-text-weight-light is-size-3 mb-4">
            查收您的電子郵件
          </h1>
        </div>
        <p class="has-text-centered mb-3">
          請儘速至信箱點選驗證連結，以完成帳號啟用：）
        </p>
        <p class="has-text-centered has-text-weight-medium mb-5 register-completed--email">
          {{ email }}
        </p>
        <img
          alt="Register Completed"
          class="mb-4"
          src="@/assets/images/register-completed-image.svg"
        />
        <b-button
          :loading="resending"
          class="mb-2 mt-4 register-completed--resend-btn"
          expanded
          outlined
          type="is-primary"
          @click="resend"
        >
          重發驗證信
        </b-button>
        <p class="font-small has-text-black mb-4">
          找不到驗證信？請檢查您的垃圾郵件資料夾
        </p>
      </div>
    </div>
    <footer class="mb-5">
      <p class="copyright has-text-centered has-text-dark-grey">
        如果您無法收到認證電子郵件，請聯絡客戶服務
        <a class="link-decoration-none" href="mailto:contact@takeorder.tw">
          contact@takeorder.tw
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
import RegisterCompleted from './RegisterCompleted';

export default RegisterCompleted;
</script>

<style lang="scss" scoped>
@import 'RegisterCompleted';
</style>
